export default "__VITE_ASSET__RV$UyS_u__"